import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Diamond } from "components/icons";
import { fontWeight } from "config/Theme/options";
import { SubscriptionType } from "types/enums";

interface IProps {
  size?: "small" | "normal";
}

export const StyledSubscriptionBox = styled(Box)<{
  size?: "small" | "normal";
}>(({ theme, size }) => ({
  borderRadius: "12px",
  padding: theme.spacing(size === "small" ? 0.5 : 1, size === "small" ? 1 : 2),
  fontWeight: fontWeight.semiBold,
  fontSize: size === "small" ? "0.75rem" : "0.9735rem",
  display: "flex",
  alignItems: "center",
  gap: size === "small" ? theme.spacing(0.5) : theme.spacing(1),
  backgroundColor: "black",
  color: "white",
}));

const SubscriptionBadge = ({ size = "normal" }: IProps) => {
  return (
    <StyledSubscriptionBox size={size}>
      <Diamond sx={{ fontSize: size === "small" ? "1rem" : "1.5rem" }} />
      {SubscriptionType.PRO}
    </StyledSubscriptionBox>
  );
};

export default SubscriptionBadge;
